import { HeaderBase } from "../../shared/HeaderBase";
import logo from "../images/IMS-Logo.png";

export const Header = () => (
  <HeaderBase
    brand={
      <>
        <img
          src={logo}
          alt="Ingenico Marketing Solutions"
          style={{
            height: 80,
            width: 124,
            margin: -16,
          }}
        />
        <span className="ml-4">Loyalty Portal</span>
      </>
    }
  />
);
